import type { LoginAction } from './actions';
import { LoginActionTypes } from './actionTypes';

import type { Session } from '@cobliteam/common-types';

import {
  type WebData,
  webDataError,
  webDataFetching,
  webDataNotAsked,
  webDataSuccess,
} from '@cobliteam/api-lib';

export interface LoginState {
  loginWebData: WebData<any>;
  updateAccountWebData: WebData<void>;
  session: Session | null;
  attributes: any;
}

export const loginInitialState: LoginState = {
  loginWebData: webDataNotAsked(),
  updateAccountWebData: webDataNotAsked(),
  session: null,
  attributes: null,
};

export const loginReducer = (
  state: LoginState = loginInitialState,
  action: LoginAction
): LoginState => {
  switch (action.type) {
    case LoginActionTypes.LOGIN_SUCCEEDED:
      const { session, attributes } = action.payload;
      return {
        ...state,
        loginWebData: webDataSuccess(session),
        session,
        attributes,
      };

    case LoginActionTypes.LOGIN_FAILED:
      return {
        ...state,
        loginWebData: webDataError(action.errorMessage, undefined, action.data),
      };

    case LoginActionTypes.LOGOUT_REQUEST:
      return {
        ...state,
        loginWebData: webDataFetching(),
      };

    case LoginActionTypes.LOGOUT_SUCCEEDED:
      return {
        ...state,
        loginWebData: webDataNotAsked(),
        session: null,
      };

    case LoginActionTypes.LOGOUT_FAILED:
      return {
        ...state,
        loginWebData: webDataError(undefined),
      };

    case LoginActionTypes.SESSION_REQUEST:
      return {
        ...state,
        loginWebData: webDataFetching(),
      };

    case LoginActionTypes.UPDATE_ACCOUNT_REQUEST:
      return {
        ...state,
        updateAccountWebData: webDataFetching(),
      };

    case LoginActionTypes.UPDATE_ACCOUNT_SUCCEEDED:
      return {
        ...state,
        updateAccountWebData: webDataSuccess(undefined),
        loginWebData: webDataSuccess(action.payload),
        session: action.payload,
      };

    case LoginActionTypes.UPDATE_ACCOUNT_FAILED:
      return {
        ...state,
        updateAccountWebData: webDataError(undefined),
      };

    default:
      return state;
  }
};
